import { UPDATE_SAMPLE_REPORT_BY_REF } from "../constants";
import { getLocalStorage } from "../utils";

export interface UpdateSampleReportByRefRequest {
  docReference: string;
  reportRef: string[];
}

export const updateSampleReportByRef = async (request: UpdateSampleReportByRefRequest): Promise<any> => {
  try {
    const sampleReportResponse = await fetch(UPDATE_SAMPLE_REPORT_BY_REF, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLocalStorage("id-token")}`,
      },
      body: JSON.stringify(request),
    });
    const sampleReportContent = await sampleReportResponse.json();

    return sampleReportContent.data.message === "Success";
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error", error);
  }

  return false;
};
